import { render, staticRenderFns } from "./pageTitleForm.vue?vue&type=template&id=6e55fa78&scoped=true&"
import script from "./pageTitleForm.vue?vue&type=script&lang=js&"
export * from "./pageTitleForm.vue?vue&type=script&lang=js&"
import style0 from "./pageTitleForm.vue?vue&type=style&index=0&id=6e55fa78&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e55fa78",
  null
  
)

export default component.exports